export default "__VITE_ASSET__Bc7_iJMQ__";